module.exports = __webpack_public_path__ + "static/media/image (17).5baf9375.jpg";